import React from "react";
import styled from "styled-components";
import Header from "../commons/Header";
import Footer from "../commons/Footer";
import ToastProvider from "../commons/Toast";
import ProvideLandingSearch from "../providers/ProvideLandingSearch";

const Page = styled.div`
  background: #ffffff;
  min-height: 100vh;
  color: #1f2937;
  font-family: "Montserrat", sans-serif;

  &[data-theme="dark"] {
    background: #0f172a;
    color: #f3f4f6;
  }
`;

// Shared shell for the three Sertifikasi rebrand pages (Course, Curriculum,
// Lesson). Mirrors `webinars/App.jsx` — dark-mode handoff via [data-theme]
// + shared <Header>/<Footer> layout.
export default function SertifikasiApp({ theme = "light", children }) {
  const resolved = theme === "dark" ? "dark" : "light";

  React.useEffect(() => {
    document.documentElement.setAttribute("data-theme", resolved);
    return () => document.documentElement.removeAttribute("data-theme");
  }, [resolved]);

  return (
    <ProvideLandingSearch>
      <ToastProvider>
        <Page data-theme={resolved}>
          <Header />
          {children}
          <Footer />
        </Page>
      </ToastProvider>
    </ProvideLandingSearch>
  );
}
